<template>
  <div>
    <v-alert dark color="black">
      <h3 class="headline">CC Management</h3>
    </v-alert>
    <div class="pa-3">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          v-model="cc.name"
          outlined
          :rules="rules"
          label="Name"
          required
        ></v-text-field>

        <v-text-field
          v-model="cc.description"
          outlined
          label="Description"
          required
        ></v-text-field>
        <v-row class="my-2">
          <v-col cols="6">
            <v-btn block class="cust-border-btn-color" @click="cancel">
              Cancel
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              :disabled="!valid"
              block
              class="cust-btn-color"
              @click="validate"
            >
              Confirm
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import Service from "../services/";
export default {
  name: "CCForm",
  props: {
    model: {
      type: Object,
    },
  },
  data: () => ({
    valid: true,
    cc: {},
    rules: [(v) => !!v || "This Field is required"],
  }),
  created() {
    this.cc = this.model;
  },
  methods: {
    cancel() {
      this.$emit("SucessClick");
    },
    validate() {
      if (this.$refs.form.validate()) {
        if (this.cc.id) {
          //edit
          this.$store.dispatch("Loading/onSetLoading", true);
          Service.cc.edit(this.cc).then((res) => {
            if (res.status === 201) {
              this.$store.dispatch("Loading/onSetLoading", false);
              this.$emit("SucessClick");
            }
          });
        } else {
          //create
          this.$store.dispatch("Loading/onSetLoading", true);
          Service.cc.create(this.cc).then((res) => {
            if (res.status === 200) {
              this.$store.dispatch("Loading/onSetLoading", false);
              this.$emit("SucessClick");
            }
          });
        }
      }
    },
  },
};
</script>

<style>
</style>